/**
 * Señal para que la página Tareas recargue sin F5.
 * Ampliar: poll + visibility ya cubren WA entrante; esto acelera tras acciones locales / otras pestañas.
 */
export const TAREAS_REFRESH_EVENT = "vc-tareas-changed";
export const TAREAS_REFRESH_CHANNEL = "vc-tareas";

export function notifyTareasChanged(detail = {}) {
  try {
    window.dispatchEvent(new CustomEvent(TAREAS_REFRESH_EVENT, { detail }));
  } catch {
    /* ignore */
  }
  try {
    const bc = new BroadcastChannel(TAREAS_REFRESH_CHANNEL);
    bc.postMessage({ type: "refresh", ...detail, at: Date.now() });
    bc.close();
  } catch {
    /* BroadcastChannel no disponible */
  }
}
